@if (showGuide$ | async) {
  @if (currentStep) {
    <app-standard-page>
      <div class="card vertical ms-0 container p-0">
        <div class="guide-content p-3">
          @if (isLastStep) {
            <h3>Congratulations, you've completed the setup guide!</h3>
            <p class="mb-0">
              Now you can create journals, run reports and manage changes to
              your assets.
            </p>
            <div class="d-flex justify-content-between">
              <div></div>
              <div>
                <button
                  type="button"
                  class="btn btn-primary btn-guide ms-2"
                  (click)="onDone()"
                >
                  Done
                </button>
              </div>
            </div>
          }
          @if (!isLastStep) {
            @if (showExpandedGuide$ | async; as expanded) {
              <div>
                <div class="d-flex justify-content-between">
                  <h2 class="text-onboarding mb-4">
                    Let's get your depreciation automated!
                  </h2>
                  <button
                    type="button"
                    class="btn-close"
                    aria-label="Close"
                    (click)="onClose()"
                  ></button>
                </div>

                <p class="mt-2">
                  This guide will take you through the steps to get quickly set
                  up.
                </p>

                <ng-container [ngTemplateOutlet]="progress"></ng-container>

                <div class="expanded mx-4 px-4 pt-2 w-75">
                  @for (step of setupGuideSteps?.slice(0, -1); track step) {
                    <div>
                      <div class="pb-2">
                        @switch (step.status) {
                          @case (OnboardingRegisterGuideStepStatus.Completed) {
                            <h4 class="text-primary">
                              <i-lucide name="check-circle"></i-lucide>
                              Step {{ step.stepId }}: {{ step.name }}
                            </h4>
                          }

                          @case (OnboardingRegisterGuideStepStatus.Skipped) {
                            <h4 class="text-primary">
                              <i-lucide name="x-circle"></i-lucide>
                              Step {{ step.stepId }}: {{ step.name }} (skipped)
                            </h4>
                          }

                          @case (OnboardingRegisterGuideStepStatus.Next) {
                            <div class="current-step rounded">
                              <h3 class="color-demo">
                                <i-lucide name="arrow-right-circle"></i-lucide>
                                Step {{ step.stepId }}: {{ step.name }}
                              </h3>

                              <p class="">{{ currentStep.description }}</p>

                              @if (isOnCurrentStepPage) {
                                <app-alert type="info">
                                  {{ currentStep.onPageDescription }}
                                </app-alert>
                              }

                              <div class="d-flex justify-content-end">
                                <div>
                                  @if (currentStep.isSkippable) {
                                    <button
                                      type="button"
                                      class="btn btn-outline btn-guide ms-2"
                                      (click)="onSkip()"
                                    >
                                      Skip
                                    </button>
                                  }
                                  @if (!isOnCurrentStepPage) {
                                    <button
                                      type="button"
                                      class="btn btn-primary btn-guide ms-2"
                                      (click)="onAction()"
                                    >
                                      {{ currentStep.actionLabel }}
                                    </button>
                                  }
                                </div>
                              </div>
                            </div>
                          }

                          @case (OnboardingRegisterGuideStepStatus.NotStarted) {
                            <h4>
                              <i-lucide name="circle"></i-lucide>
                              Step {{ step.stepId }}: {{ step.name }}
                            </h4>
                          }
                        }
                      </div>
                    </div>
                  }
                </div>
                <button
                  type="button"
                  class="btn btn-link ps-0"
                  (click)="onboardingService.expandGuide(false)"
                >
                  <i-lucide name="minus-circle"></i-lucide>
                  Hide other steps
                </button>
              </div>
            } @else {
              @if (!isLastStep) {
                <div class="d-flex justify-content-between">
                  <ng-container [ngTemplateOutlet]="progress"></ng-container>
                  <button
                    type="button"
                    class="btn-close"
                    aria-label="Close"
                    (click)="onClose()"
                  ></button>
                </div>
                <h3>Step {{ currentStep.stepId }}: {{ currentStep.name }}</h3>
                <p class="mb-0">{{ currentStep.description }}</p>

                @if (isOnCurrentStepPage) {
                  <app-alert type="info" class="m-3">
                    {{ currentStep.onPageDescription }}
                  </app-alert>
                }

                <div class="d-flex justify-content-between">
                  <button
                    type="button"
                    class="btn btn-link ps-0"
                    (click)="onboardingService.expandGuide(true)"
                  >
                    <i-lucide name="plus-circle"></i-lucide>
                    See all steps
                  </button>
                  <div>
                    @if (currentStep.isSkippable) {
                      <button
                        type="button"
                        class="btn btn-outline btn-guide ms-2"
                        (click)="onSkip()"
                      >
                        Skip
                      </button>
                    }
                    @if (!isOnCurrentStepPage) {
                      <button
                        type="button"
                        class="btn btn-primary btn-guide ms-2"
                        (click)="onAction()"
                      >
                        {{ currentStep.actionLabel }}
                      </button>
                    }
                  </div>
                </div>
              }
            }
          }
        </div>
      </div>
    </app-standard-page>
  }
}

<ng-template #progress>
  <div class="d-flex justify-content-start">
    <h4>
      <i-lucide name="compass"></i-lucide>

      Setup guide
    </h4>

    <div class="ms-3 d-flex">
      <div class="progress mx-3">
        <div
          [style]="'width: ' + progressPercent + '%'"
          class="progress-bar color-guide"
          role="progressbar"
        ></div>
      </div>
      {{ progressPercent | number: '1.0-0' }}% completed
    </div>
  </div>
</ng-template>
